// extracted by mini-css-extract-plugin
export default {"hidden":"withError_hidden__csOKp","default":"withError_default__pNHQn"};